import { memo, useEffect } from 'react'
import { Platform } from '@/env'
import { useCommon } from '@/core/useCommon'
import { useWebsiteStore } from '@/website/useWebsiteStore'
import { loginByToken, useUserStore } from '@/store/user/useUserStore'
import { InitConfig } from '@/store/config/useConfigStore'
import { createUrl } from '@/utils'
import { useSessionStore } from '@/website/useSessionStore'
import { NavProvider, router } from './NavProvider'
import { ROUTES } from '@/env/routes'

/** 預設 theme */
const InitTheme = () => {
  return null
}

/**
 * 依照服務的初始化，注意效能
 */
export const ServiceInitialized = memo(() => {
  const { locale = Platform.LOCALE } = useCommon()
  const token = useUserStore((state) => state.token)
  const isSimplePage = useWebsiteStore((state) => state.isSimplePage)

  /** 網址帶的 token 自動登入 */
  useEffect(() => {
    // const url = createUrl(document.URL)
    const token = useSessionStore.getState()?.params?.token || ''

    if (!token) return
    loginByToken(token)
  }, [])

  return (
    <>
      {/*預設 theme*/}
      <InitTheme />

      {/* push, replace, back */}
      <NavProvider />

      {/*簡易版型若需要初始化，依照需求掛在版型中，不需要掛在這*/}
      {!isSimplePage && (
        <>
          {/*初始化 Config*/}
          <InitConfig locale={locale} token={token} />
        </>
      )}
    </>
  )
})

ServiceInitialized.displayName = 'ServiceInitialized'
